import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getInitials } from './utils'

import type { FC } from 'react'

type Props = {
  username: string
}

export const UserMenuInitials: FC<Props> = ({ username }) => {
  if (!username) {
    return null
  }

  return (
    <div className="flex items-center">
      <span className="flex size-8 items-center justify-center rounded-full bg-dark text-sm font-medium">
        {getInitials(username)}
      </span>
      <span className="hidden lg:flex">
        <FontAwesomeIcon icon={faAngleDown} className="ml-2 w-4" />
      </span>
    </div>
  )
}
